import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import React from 'react'

import ToggleSwitch from './fields/ToggleSwitch'
import { useTracking } from 'hooks/useTracking'
import { EVENT_NAMES } from 'lib/tracking'

export type Props = {
	isEnabled: boolean
	onChange: (isEnabled: boolean) => Promise<{ isEnabled: boolean } | void>
	ariaName: string
	trackingName?: string
	onClick?: (event: React.MouseEvent<HTMLInputElement>) => void
	disabled?: boolean
	compact?: boolean
	label?: string
}

const Switch = styled(ToggleSwitch)`
	padding: 0;
`

function FeatureToggle({ isEnabled, onChange, ariaName, trackingName, onClick, disabled, compact, label = '' }: Props) {
	const [isEnabledLocal, setIsEnabledLocal] = React.useState(isEnabled)
	const track = useTracking()
	const router = useRouter()

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const isEnabled = event.target.checked
		if (trackingName) {
			track(EVENT_NAMES.FEATURE_TOGGLED, {
				name: trackingName,
				enabled: isEnabled,
				source: router.asPath,
				isNestedRoute: router.asPath.split('/').length > 3,
			})
		}
		setIsEnabledLocal(isEnabled)
		onChange(isEnabled).catch(() => setIsEnabledLocal((currentIsEnabledLocal) => !currentIsEnabledLocal))
	}

	React.useEffect(() => {
		setIsEnabledLocal(isEnabled)
	}, [isEnabled])

	return (
		<Switch
			ariaLabel={ariaName}
			label={label}
			checked={isEnabledLocal}
			onChange={handleChange}
			onClick={onClick}
			disabled={disabled}
			compact={compact}
		/>
	)
}

export default FeatureToggle
